import * as angular from "angular";

export default angular
	.module("vesl.extensions.json-schema.base64FileUpload.controller", [])
	.directive("base64FileUpload", [
		"base64FileUploadConfig",
		"$timeout",
		function(base64FileUploadConfig, $timeout, $logger) {
			return {
				restrict: "A",
				require: "ngModel",
				scope: true,
				link: function(scope, element, attrs, ngModel) {
					scope.ngModel = ngModel;
					scope.dropAreaHover = false;
					scope.file = undefined;
					scope.fileError = false;
					scope.dropText = base64FileUploadConfig.dropText || "Click here or drop files to upload";

					const validateFile = function(file) {
						let valid = true;
						const schema = scope.$eval(attrs.base64FileUpload).schema;

						if(file.size > parseInt(schema.maxSize, 10)) {
							valid = false;
							ngModel.$setValidity("base64FileUploadSize", false);
						} else {
							ngModel.$setValidity("base64FileUploadSize", true);
						}

						scope.$apply();

						return valid;
					};

					const getFile = function(file) {
						if(!file) {
							return;
						}

						if(!validateFile(file)) {
							return;
						}

						const reader = new FileReader();

						scope.file = file;
						scope.file.ext = file.name.split(".").slice(-1)[0];
						scope.file.src = URL.createObjectURL(file);
						scope.hasFile = true;
						// just a simple conversion to human readable size.
						// For now not bothering with large sizes.
						let fileSize = file.size / 1024;
						let unit = "kB";
						if(fileSize > 1024) {
							fileSize = fileSize / 1024;
							unit = "MB";
						}

						scope.file.humanSize = fileSize.toFixed(1) + " " + unit;

						reader.onloadstart = function() {
							$timeout(function() {
								scope.loadingFile = true;
							}, 0);
						};

						reader.onload = function(e) {
							$timeout(function() {
								scope.loadingFile = false;
							}, 0);
            
							const prefix = "file:" + file.name + ";";
							ngModel.$setViewValue(prefix + e.target.result);
						};

						reader.readAsDataURL(file);
						scope.$apply();
					};

					scope.isImage = function(file) {
						if(!file) {
							return false;
						}

						return file.type.indexOf("image") > -1;
					};

					scope.removeFile = function(e) {
						e.preventDefault();
						e.stopPropagation();
						scope.file = undefined;
						scope.hasFile = false;
						ngModel.$setViewValue(undefined);
					};

					element.find("input").bind("change", function(e) {
						getFile(e.target.files[0]);
					});

					const dropArea = document.querySelector("#base-64-file-drop-button");
					const inputField = document.querySelector("#base-64-file-input-area");

					const clickArea = function(e) {
						e.stopPropagation();
						inputField.click();
					};

					const dragOver = function(e) {
						e.preventDefault();
						e.stopPropagation();
						$timeout(function() {
							scope.dropAreaHover = true;
						}, 0);
					};

					const dragLeave = function(e) {
						e.preventDefault();
						e.stopPropagation();
						$timeout(function() {
							scope.dropAreaHover = false;
						}, 0);
					};

					const drop = function(e) {
						dragLeave(e);
						getFile(e.dataTransfer.files[0]);
					};

					dropArea.addEventListener("click", clickArea, false);
					dropArea.addEventListener("touchstart", clickArea, false);
					dropArea.addEventListener("dragenter", dragOver, false);
					dropArea.addEventListener("dragleave", dragLeave, false);
					dropArea.addEventListener("dragover", dragOver, false);
					dropArea.addEventListener("drop", drop, false);

					scope.$watch(
						() => ngModel.$modelValue,
						(newValue) => {
							if(newValue === undefined || newValue === null) {
								scope.file = undefined;
								scope.hasFile = false;
							}
						}
					);

					scope.$on("$destroy", function() {
						dropArea.removeEventListener("click", clickArea, false);
						dropArea.removeEventListener("touchstart", clickArea, false);
						dropArea.removeEventListener("dragenter", dragOver, false);
						dropArea.removeEventListener("dragleave", dragLeave, false);
						dropArea.removeEventListener("dragover", dragOver, false);
						dropArea.removeEventListener("drop", drop, false);
					});

				}
			};
		}
	])
	.name;
